import type { LocationFeatureDetails } from '../../types/Location';
import type { WizardLocationFeature } from './types';

export type DetailValue = LocationFeatureDetails[string] | null | undefined;

const isEmpty = (value: DetailValue): boolean =>
  value == null || value === '' || (Array.isArray(value) && value.length === 0);

/**
 * Adds or removes a feature. Removing drops its details; with `trackDetails` a checked feature
 * sends `restore` or `{}`, so the API clears anything saved before an earlier uncheck.
 */
export const toggleFeature = (
  features: WizardLocationFeature[],
  feature: string,
  trackDetails: boolean,
  restore?: LocationFeatureDetails
): WizardLocationFeature[] => {
  if (features.some((f) => f.feature === feature)) {
    return features.filter((f) => f.feature !== feature);
  }
  return [...features, trackDetails ? { feature, details: restore ?? {} } : { feature }];
};

/** Sets one sub-field on a selected feature; empty values remove the key. */
export const setFeatureDetail = (
  features: WizardLocationFeature[],
  feature: string,
  key: string,
  value: DetailValue
): WizardLocationFeature[] =>
  features.map((f) => {
    if (f.feature !== feature) return f;
    const details: LocationFeatureDetails = { ...(f.details || {}) };
    if (isEmpty(value)) {
      delete details[key];
    } else {
      details[key] = value as LocationFeatureDetails[string];
    }
    return { ...f, details };
  });
